import React from 'react'
import _ from 'lodash'
import yn from 'yn'

import BkFlowNavigationDetailsLocationContact from './BkFlowNavigationDetailsLocationContact'

const BkFlowNavigationDetailsLocationSidebar = props => {
	const {
		configData,
		availabilityData,
		propertyNumbers,
		propertyAddress,
		propertyEmails
	} = props

	const hotelLabels = configData.hotel.labels[0]

	return (
		<div className="bk-flow-navigation-details__location">
			<div className="bk-flow-navigation-details__location-row location-row--gap location-hotel">
				<p className="u-font-bold u-remove-margin">
					{
						!_.isEmpty(availabilityData) &&
						_.get(availabilityData, '[0][0].basicPropertyInfo.hotelName') ?
						availabilityData[0][0].basicPropertyInfo.hotelName
					:
						'--'
					}
				</p>
			</div>

			{ propertyNumbers &&
				propertyNumbers.reservations &&
					<BkFlowNavigationDetailsLocationContact
						parentClasses={propertyNumbers.reservationsAlt || propertyNumbers.property ?
							'location-reservations-phone'
						:
							'location-reservations-phone location-row--gap'
						}
						disableContactLabel={yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DISABLE_LOCATION_LABELS)}
						contactLabel={hotelLabels.reservationsPhone ? hotelLabels.reservationsPhone : 'Reservations'}
						contactType='phone'
						contactValue={propertyNumbers.reservations}
					/>
			}

			{ propertyNumbers &&
				propertyNumbers.reservationsAlt &&
					<BkFlowNavigationDetailsLocationContact
						parentClasses='location-reservations-phone-alt location-row--gap'
						disableContactLabel={yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DISABLE_LOCATION_LABELS)}
						contactLabel={hotelLabels.reservationsAlt ? hotelLabels.reservationsPhoneAlt : 'Reservations'}
						contactType='phone'
						contactValue={propertyNumbers.reservationsAlt}
					/>
			}

			{ propertyNumbers &&
				propertyNumbers.property &&
					<BkFlowNavigationDetailsLocationContact
						parentClasses={propertyNumbers.property ? 'location-hotel-phone' : 'location-hotel-phone location-row--gap'}
						disableContactLabel={yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DISABLE_LOCATION_LABELS)}
						contactLabel={hotelLabels.propertyPhone ? hotelLabels.propertyPhone : 'Hotel'}
						contactType="phone"
						contactValue={propertyNumbers.property}
					/>
			}

			{ propertyNumbers &&
				propertyNumbers.propertyAlt &&
					<BkFlowNavigationDetailsLocationContact
						parentClasses="location-hotel-phone-alt location-row--gap"
						disableContactLabel={yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DISABLE_LOCATION_LABELS)}
						contactLabel={hotelLabels.propertyPhoneAlt ? hotelLabels.propertyPhoneAlt : 'Hotel'}
						contactType="phone"
						contactValue={propertyNumbers.propertyAlt}
					/>
			}


			{ propertyEmails &&
				propertyEmails.reservations &&
					<BkFlowNavigationDetailsLocationContact
						parentClasses={propertyEmails.property ? 'location-reservations-email' : 'location-reservations-email location-row--gap'}
						disableContactLabel={yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DISABLE_LOCATION_LABELS)}
						contactLabel={hotelLabels.reservationsEmail ? hotelLabels.reservationsEmail : 'Email'}
						contactType="email"
						contactValue={propertyEmails.reservations}
					/>
			}

			{ propertyEmails &&
				propertyEmails.property &&
					<BkFlowNavigationDetailsLocationContact
						parentClasses="location-property-email location-row--gap"
						disableContactLabel={yn(process.env.REACT_APP_COMPONENT_NAVIGATION_DISABLE_LOCATION_LABELS)}
						contactLabel={hotelLabels.propertyEmail ? hotelLabels.propertyEmail : 'Email'}
						contactType="email"
						contactValue={propertyEmails.property}
					/>
			}

			{ propertyAddress &&
				propertyAddress.addressLine &&
				propertyAddress.addressLine[0] &&
				<div className="bk-flow-navigation-details__location-row location-address">
					<p className="label u-remove-margin">{ hotelLabels.address }:&nbsp;</p>
					<p className="value u-remove-margin">
						{ propertyAddress.addressLine[0] }
						{ propertyAddress.addressLine[1] && ', ' + propertyAddress.addressLine[1] }
						{ propertyAddress.cityName && ', ' + propertyAddress.cityName }
						{ propertyAddress.stateProv && ', ' + propertyAddress.stateProv }
						{ propertyAddress.postalCode && ' ' + propertyAddress.postalCode }
						{ propertyAddress.countryName && ', ' + propertyAddress.countryName }
					</p>
				</div>
			}


		</div>
	)
}

export default BkFlowNavigationDetailsLocationSidebar


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationDetailsLocationSidebar.js